<!--
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-06-13 16:19:11
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-18 17:11:44
-->
<template>
  <Dropdown>
    <a class="lang-switch" @click.prevent>
      {{ LangType[settingStore.locale] }}
    </a>
    <template #overlay>
      <Menu @click="handleMenuClick" class="menu">
        <MenuItem v-for="(item, key) in langList" :key="item.value" class="menu-item">{{ item.label }} </MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { Dropdown, Menu, MenuItem } from 'ant-design-vue'
  import type { MenuProps } from 'ant-design-vue'
  import { useSettingStore } from '@/store/sysSetting'
  import LangType from '@/utils/i18n/LangType'
  import { dictService } from '@/service/api'
  import { useApi } from '@xinghai/site-common'
  import { isSuccess, localeMap } from '@/utils'
  import dayjs from 'dayjs'
  type Lang = keyof typeof LangType
  const VITE_I18N_TYPE = import.meta.env.VITE_I18N_TYPE
  const langList = Object.keys(LangType).map((key) => ({
    label: LangType[key],
    value: key,
  })).filter((item) => VITE_I18N_TYPE.includes(item.label))
  console.log(langList);
  
  const sysSetting = useSettingStore()
  
  const locale = computed(() => sysSetting.locale)
  dayjs.locale(localeMap[locale.value].dayjs)
  interface Props {
    /**是否重载页面 */
    reload?: boolean
  }
  const props = defineProps<Props>()
  const settingStore = useSettingStore()

  const { fetchData, result } = useApi(dictService.getI18n)
  fetchData().then((res: any) => {
    if (!isSuccess(res)) return
    settingStore.langJson = result.value
  })

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    settingStore.locale = e.key as Lang
    dayjs.locale(localeMap[e.key].dayjs)
    const res = await fetchData()
    if (!isSuccess(res)) return
    settingStore.langJson = result.value
    if (props.reload) {
      location.reload()
    }
  }
</script>
<style lang="less" scoped>
  .lang-switch {
    height: 32px;
    line-height: 32px;
    width: 56px;
    text-align: center;
    border-radius: 16px;
    background-color: @white;
    color: @primary-color;
    display: inline-block;
  }

  .menu {
    width: 80px;
    text-align: center;

    .menu-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding-bottom: 20px;
    }
  }
</style>
